exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slot-embeed[data-v-6965205a] {\n  top: 2px !important;\n  right: 4px !important;\n  z-index: 10;\n}\n", ""]);

// exports
